<section>
    <div class="container" id="how-it-works">
        <h1>Simple pricing that scales with you</h1>
        <p>
            Start collecting feedback in minutes. Upgrade when you’re ready.
        </p>
        <div class="carousel carousel-light">
            <a [href]="freeUrl$ | async" class="carousel-item item__1">
                <div class="item-content">
                    <h2>Free</h2>
                    <p>For trying things out</p>
                    <p><b>10</b> free feedback submissions / month</p>
                    <div class="price">€ 0<sub>/month</sub></div>
                </div>
                <div class="item-footer">
                    <span class="btn" *ngIf="(isLoggedIn$ | async) == false">Get started FREE</span>
                    <span class="btn" *ngIf="(isLoggedIn$ | async) == true">Go to your dashboard</span>
                </div>
            </a>
            <a [href]="subscribeStarterUrl$ | async" class="carousel-item item__2">
                <div class="item-content">
                    <h2>Starter</h2>
                    <p>For small products &amp; indie makers</p>
                    <p><b>50</b> feedback submissions / month</p>
                    <div class="price">€ 5<sub>/month</sub></div>
                </div>
                <div class="item-footer">
                    <span class="btn">Subscribe to STARTER</span>
                </div>
            </a>
            <a [href]="subscribeProUrl$ | async" class="carousel-item item__3">
                <div class="item-content">
                    <h2>Pro</h2>
                    <p>For teams that take feedback seriously</p>
                    <p><b>Unlimited</b> feedback</p>
                    <div class="price">€ 20<sub>/month</sub></div>
                </div>
                <div class="item-footer">
                    <span class="btn">Subscribe to PRO</span>
                </div>
            </a>
        </div>

        <h2><i class="fa fa-shield-alt"></i> No feedback is ever lost.</h2>
        <p>
            If you reach your monthly limit, new feedback is safely stored and becomes available as soon as you upgrade.
        </p>
    </div>
</section>
